import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Box,
  Card,
  IconButton,
  Tooltip,
} from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useLocation } from "react-router-dom";
import { StyledTableRow, StyledTableCell } from "../style/style";
import { timeStamp } from "../apicall/commonFunction";

export default function ChangeBillingTypeList({
  devices,
  page,
  totalPage,
  setPage,
  setSelectedDevice,
  setOpenEditModal,
  setOpenViewModal,
}) {
  const { pathname } = useLocation();

  const handlePageChange = (_, value) => setPage(value);

  const handleEdit = (device) => {
    setSelectedDevice(device);
    setOpenEditModal(true);
  };
  const handleView = (device) => {
    setSelectedDevice(device);
    setOpenViewModal(true);
  };

  // Define columns once
  const columns = [
    {
      id: "company_name",
      label: "Company Name",
      render: (d) => d.company_name,
    },
    {
      id: "device_name",
      label: "Device Name",
      render: (d) => d.device_group.device_name,
    },
    {
      id: "device_type",
      label: "Device Type",
      render: (d) => d.device_group.device_type,
    },
    {
      id: "status",
      label: "Request Status",
      render: (d) => (d.status ? "Changed" : "In-Process"),
    },
    {
      id: "requested_on",
      label: "Requested On",
      render: (d) => {
        const raw = d.billing_type_change_requested_on;
        if (!raw) return "NA";
        const iso = raw
          .replace(" ", "T")
          .replace(/(\.\d{3})\d+/, "$1");
    
        // Parse, get ms since epoch, convert to whole seconds
        const seconds = Math.floor(new Date(iso).getTime() / 1000);
    
        // Calling timeStamp formatter
        return timeStamp(parseInt(seconds, 10));
      },
    },
    {
      id: "current_billing_type",
      label: "Current Billing Type",
      render: (d) => d.billing_type,
    },
    {
      id: "new_billing_type",
      label: "New Billing Type",
      render: (d) => d.new_billing_type,
    },
    {
      id: "actions",
      label: "Action",
      render: (d) => (
        <div style={{ display: "flex" }}>
          {pathname === "/admin" && (
            <Tooltip
              title={d.status ? "Device Already Replaced" : "Replace Device"}
            >
              <span>
                {" "}
                {/* span to handle disabled tooltip */}
                <IconButton
                  size="small"
                  disabled={d.status}
                  onClick={() => handleEdit(d)}
                >
                  <ModeEditIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <Tooltip title="View Details">
            <span>
              <IconButton
                size="small"
                onClick={() => {
                  handleView(d);
                }}
              >
                <RemoveRedEyeIcon color="primary" />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Box>
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <StyledTableCell key={col.id}>
                    <b>{col.label}</b>
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {devices?.map((device) => (
                <StyledTableRow key={device.id}>
                  {columns.map((col) => (
                    <StyledTableCell key={col.id}>
                      {col.render(device)}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
            <Pagination
              count={totalPage}
              page={page}
              variant="outlined"
              color="primary"
              onChange={handlePageChange}
              sx={{ p: 2 }}
            />
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}
